const styles = {
    picker: {
        width: "100% !important",
        marginTop: "2rem"
    },
    addColor: {
        width: "100%",
        padding: "1rem",
        marginTop: "1rem"
    },
    colorInput: {
        width: "100%",
        marginTop: "1rem"
    },
    chromePickerContainer: {
      width: "70%"
    }
}

export default styles;